export default __webpack_public_path__ + "static/media/EditIcon.2125163c.svg";